import { createSystemMessageSiteCoreKeys } from "../siteCore/SiteCoreKeys";

export const CreateMessageKey = {
  countryAndLanguage: "countryAndLanguage",
  messageTitle: "messageTitle",
  messageDescription: "messageDescription",
  persistence: "persistence",
  addLinkInformation: "addLinkInformation",
  linkName: "linkName",
  linkUrl: "linkUrl",
  linkPosition: "linkPosition",
  timeZone: "timeZone",
  fromDate: "fromDate",
  toDate: "toDate",
} as const;

export const createSystemMessageFormDefaultValues = {
  [CreateMessageKey.countryAndLanguage]: [],
  [CreateMessageKey.messageTitle]: "",
  [CreateMessageKey.messageDescription]: "",
  [CreateMessageKey.persistence]: false,
  [CreateMessageKey.addLinkInformation]: false,
  [CreateMessageKey.linkName]: "",
  [CreateMessageKey.linkUrl]: "",
  [CreateMessageKey.linkPosition]:
    createSystemMessageSiteCoreKeys.belowTheMessage,
  [CreateMessageKey.timeZone]: "",
  [CreateMessageKey.fromDate]: "",
  [CreateMessageKey.toDate]: "",
};

export interface TimeZoneType {
  id: string;
  title: string;
  standardCodes: {
    itemCodeStandardName: string;
    standardCodeValue: string;
  }[];
}

export interface SystemCountryLanguageCode {
  value: string;
  label: string;
  additionalInfo?: string;
  languageCode: string;
  countryCode: string;
}
